"use client"

import React, { useState, useRef, useEffect } from 'react';
import Image from 'next/image';

interface ImageCarouselProps {
  uploadMedia: string[];
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({ uploadMedia }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const carouselRef = useRef<HTMLDivElement>(null);

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex === 0 ? uploadMedia.length - 1 : prevIndex - 1));
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex === uploadMedia.length - 1 ? 0 : prevIndex + 1));
  };

  const handleThumbnailClick = (index: number) => {
    setCurrentImageIndex(index);
  };

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  useEffect(() => {
    if (isFullScreen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isFullScreen]);

  return (
    <div ref={carouselRef} className={`${isFullScreen ? 'fixed inset-0 z-50 bg-black w-full' : ''} overflow-x-hidden`}>
      <div className={`relative ${isFullScreen ? 'h-screen w-screen' : ''}`}>
        <Image
          src={uploadMedia[currentImageIndex]}
          alt={`Advertisement Image ${currentImageIndex + 1}`}
          className={`rounded-lg mb-4 ${isFullScreen ? 'h-screen w-screen object-contain' : 'h-96 object-contain'} `}
          width={1024}
          height={576}
          onClick={toggleFullScreen}
          quality={50}
        />
        <button onClick={handlePrevImage} className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full">&lt;</button>
        <button onClick={handleNextImage} className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full">&gt;</button>
        <div className="absolute bottom-4 right-4 bg-black bg-opacity-50 text-white px-2 py-1 text-sm rounded">{currentImageIndex + 1} / {uploadMedia.length}</div>
        <button onClick={toggleFullScreen} className="absolute top-4 right-4 bg-black bg-opacity-50 text-white p-2 rounded-full">
          {isFullScreen ? 'Exit Full Screen' : 'Full Screen'}
        </button>
      </div>

      {/* Thumbnail Gallery */}
      <div className="flex space-x-2 mb-4 overflow-x-auto">
        {uploadMedia.map((media, index) => (
          <Image
            key={index}
            src={media}
            alt={`Thumbnail ${index + 1}`}
            className="w-20 h-20 object-cover cursor-pointer rounded-md shrink-0"
            width={80}
            height={80}
            onClick={() => handleThumbnailClick(index)}
            quality={50}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;
